import { StateCodeMapping } from "@shapr3d/frontend-lib";

import { COUNTRIES_WITH_MANDATORY_STATE_SELECTOR } from "../components/ChargebeeCheckout/ChargebeeCheckoutSchema";

const EUMemberCountryCodes = [
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
];

export const isCountryInEU = (countryCode: string | undefined) => {
  return EUMemberCountryCodes.includes(countryCode ?? "");
};

export const getStateFromStateCode = (
  countryCode: string | undefined,
  stateCode: string | undefined
) => {
  if (
    !countryCode ||
    !stateCode ||
    !COUNTRIES_WITH_MANDATORY_STATE_SELECTOR.includes(countryCode)
  ) {
    return stateCode;
  }

  const states: readonly { readonly code: string; readonly name: string }[] =
    StateCodeMapping[countryCode as keyof typeof StateCodeMapping];

  if (!states) {
    return stateCode;
  }

  return states.find(({ code }) => code === stateCode)?.name ?? stateCode;
};

export const getVATNumberPrefix = (countryCode: string | undefined) => {
  if (!countryCode) {
    return "";
  }

  if (countryCode === "GR") {
    return "EL";
  }

  if (!isCountryInEU(countryCode)) {
    return "";
  }

  return countryCode;
};
